import { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Layout.css';

interface User {
    id: string;
    name: string;
    email: string;
}

interface LayoutProps {
    children: ReactNode;
    user: User;
    onLogout: () => void;
}

const navItems = [
    { path: '/', icon: '🏠', label: 'Dashboard' },
    { path: '/create', icon: '📸', label: 'Create' },
    { path: '/inventory', icon: '📦', label: 'Stock' },
    { path: '/materials', icon: '🧱', label: 'Materials' },
    { path: '/albaran', icon: '📄', label: 'Delivery' },
    { path: '/command-center', icon: '🎯', label: 'Command' },
    { path: '/credits', icon: '💳', label: 'Credits' },
];

function Layout({ children, user, onLogout }: LayoutProps) {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="layout">
            {/* Desktop Sidebar */}
            <aside className="sidebar">
                <div className="sidebar-logo" onClick={() => navigate('/')}>
                    <img src="/commerium-logo.png" alt="Commerium" className="logo-icon-img" />
                    <span className="logo-text gradient-text">Commerium</span>
                </div>

                <nav className="sidebar-nav">
                    {navItems.map((item) => (
                        <button
                            key={item.path}
                            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                            onClick={() => navigate(item.path)}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-label">{item.label}</span>
                        </button>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-profile" onClick={() => navigate('/settings')}>
                        <div className="user-avatar">
                            {user.name.charAt(0).toUpperCase()}
                        </div>
                        <div className="user-info">
                            <span className="user-name">{user.name}</span>
                            <span className="user-role">Artisan</span>
                        </div>
                    </div>
                    <button className="logout-btn" onClick={onLogout}>
                        🚪 Logout
                    </button>
                </div>
            </aside>

            {/* Main Content Area */}
            <div className="main-wrapper">
                <header className="header">
                    <div className="header-content">
                        {/* Mobile Logo */}
                        <div className="logo mobile-only" onClick={() => navigate('/')}>
                            <img src="/commerium-logo.png" alt="Commerium" className="logo-icon-img" />
                            <span className="logo-text gradient-text">Commerium</span>
                        </div>

                        <div className="header-right">
                            <button
                                className="settings-btn"
                                onClick={() => navigate('/settings')}
                                title="Settings"
                            >
                                ⚙️
                            </button>
                            <div className="user-menu mobile-hidden">
                                <span className="user-name">{user.name}</span>
                                <button className="logout-btn" onClick={onLogout}>
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </header>

                <main className="main-content">
                    <div className="container">
                        {children}
                    </div>
                </main>
            </div>

            {/* Mobile Bottom Navigation */}
            <nav className="bottom-nav">
                {navItems.map((item) => (
                    <button
                        key={item.path}
                        className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        <span className="nav-label">{item.label}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
}

export default Layout;

